// import React, { useMemo } from 'react';
// import { graphql, useStaticQuery } from 'gatsby';
// // import Img from 'gatsby-image';
// import PropTypes from 'prop-types';
// import { GatsbyImage, getImage } from "gatsby-plugin-image";

// const image = getImage(data.image.childImageSharp.gatsbyImageData);

// <GatsbyImage image={image} alt="Sample" />

// const Image = ({ fixed, src, alt, ...rest }) => {
//   const data = useStaticQuery(graphql`
//     query {
//       images: allFile(
//         filter: { internal: { mediaType: { regex: "/image/" } } }
//       ) {
//         edges {
//           node {
//             relativePath
//             extension
//             publicURL
//             childImageSharp {
//               fluid(maxWidth: 800) {
//                 ...GatsbyImageSharpFluid
//               }
//               fixed {
//                 ...GatsbyImageSharpFixed
//               }
//             }
//           }
//         }
//       }
//     }
//   `);

//   const match = useMemo(
//     () => data.images.edges.find(({ node }) => src === node.relativePath),
//     [data, src]
//   );

//   if (!match) return null;

//   const { node: { childImageSharp, publicURL, extension } = {} } = match;
    
//   if (extension === 'svg' || !childImageSharp) {
//     return <img src={publicURL} alt={alt} {...rest} />;
//   }
//   if(fixed) return <GatsbyImage fixed={childImageSharp.fixed} alt={alt} {...rest} />;

//   return <GatsbyImage fluid={childImageSharp.fluid} alt={alt} {...rest} />;

// };

// Image.propTypes = {
//   src: PropTypes.string.isRequired,
//   alt: PropTypes.string,
// };

// export default Image;


import React, { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const Image = ({ src, alt, width = 800, ...rest }) => {
  const data = useStaticQuery(graphql`
    query {
      images: allFile(
        filter: { internal: { mediaType: { regex: "/image/" } } }
      ) {
        edges {
          node {
            relativePath
            extension
            publicURL
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, quality: 80)
            }
          }
        }
      }
    }
  `);

  const match = useMemo(
    () => data.images.edges.find(({ node }) => src === node.relativePath),
    [data, src]
  );

  if (!match) return null;

  const { node: { childImageSharp, publicURL, extension } = {} } = match;

  if (extension === 'svg' || !childImageSharp) {
    return <img src={publicURL} alt={alt} {...rest} />;
  }

  const image = getImage(childImageSharp);

  return <GatsbyImage image={image} alt={alt} {...rest} />;
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default Image; 